// Comunas de la Región Metropolitana. Una sola lista para el perfil del vecino y el
// panel: antes el panel tenía 19 y el perfil 52, así que al editar a alguien de una
// comuna que faltaba, el selector mostraba el texto crudo.
export const COMUNAS_RM = [
  'Cerrillos', 'Cerro Navia', 'Conchalí', 'El Bosque', 'Estación Central',
  'Huechuraba', 'Independencia', 'La Cisterna', 'La Florida', 'La Granja',
  'La Pintana', 'La Reina', 'Las Condes', 'Lo Barnechea', 'Lo Espejo',
  'Lo Prado', 'Macul', 'Maipú', 'Ñuñoa', 'Pedro Aguirre Cerda',
  'Peñalolén', 'Providencia', 'Pudahuel', 'Quilicura', 'Quinta Normal',
  'Recoleta', 'Renca', 'San Joaquín', 'San Miguel', 'San Ramón',
  'Santiago', 'Vitacura', 'Puente Alto', 'Pirque', 'San José de Maipo',
  'Colina', 'Lampa', 'Tiltil', 'San Bernardo', 'Buin',
  'Calera de Tango', 'Paine', 'Melipilla', 'Alhué', 'Curacaví',
  'María Pinto', 'San Pedro', 'Talagante', 'El Monte', 'Isla de Maipo',
  'Padre Hurtado', 'Peñaflor',
].sort((a, b) => a.localeCompare(b, 'es'));
